import ShippingInfoBlock, { ShippingInfoBlockProps } from './ShippingInfoBlock';
import withInteractor from './ShippingInfoBlock.interactor';
import withPresenter from './ShippingInfoBlock.presenter';

export type { ShippingInfoBlockProps };
export default withInteractor(withPresenter(ShippingInfoBlock));
